'use client';
import React, { memo, useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from '@/components/Layout';
import Utils from '@/utils/util';
import Bouquet from '@/assets/img/boquet.png';
import DateIcon from '@/assets/img/day-icon.png';

import TimeIcon from '@/assets/img/time-icon.png';
import UserIcon from '@/assets/img/user-icon.png';
import { ENABLE_GOOGLE_CONVERSION, WEBSITE_URL } from '@/config';
import './DemoThankYouPage.scss';
import { useParams } from 'react-router-dom';
import { useBusiness } from '../api/getBisiness';
export default function DemoThankYouPage() {
  const userContext = useContext(UserContext);
  const { slug } = useParams();
  const [businessTz, setBusinessTz] = useState<string>();
  const businessQuery = useBusiness({ slugName: slug });
  const data = userContext?.demoConfirmationData;
  const googleMeetLink = data?.googleMeetLink;
  const selectedSlot = data?.selectedSlot;
  const hostBusinessData = data?.hostBusinessData;
  const urlParams = data?.urlParams
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  useEffect(() => {    
    if (data && ENABLE_GOOGLE_CONVERSION === 'yes') {
      triggerConversionEvent();
    }
  }, []);

  useEffect(() => {
    if (businessQuery.data) {
      setBusinessTz(businessQuery?.data.timezone);
    }
  }, [businessQuery.data]);

  const triggerConversionEvent = () => {
    const windowRef: any = window;
    if (windowRef.gtag) {
      const options = {
        user_email: data?.email,
        user_utm_campaign: urlParams?.utm_campaign,
        user_utm_source: urlParams?.utm_source,
        user_utm_medium: urlParams?.utm_medium,
        user_referrer: urlParams?.referrer,
        user_schedule_time: selectedSlot ? `${Utils.getOnlyDate(selectedSlot.start, 'MM/DD/YYYY')}-${selectedSlot.label}`   : ""
      }
      windowRef.gtag('event', 'conversion', { send_to: 'AW-16550157434/TmK6CLnhwq8ZEPq43dM9' });
      windowRef.gtag('event', 'petsked_demo_confirmation', options);
} else {
      setTimeout(() => {
        triggerConversionEvent();
      }, 1000);
    }
  };
  const backToWebsite = () => {
    window.open(WEBSITE_URL, '_self');
  };
  // declare the custom <script> literal string
  const scriptToInject = `
   <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16550157434"></script>
   <script>
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', 'G-E84SKHP8MM');
      gtag('config', 'GTM-K5NR8SWD');    
      gtag('config', 'AW-16550157434');
    </script>`;
  const InjectScript = memo((props: any) => {
    const divRef: any = useRef(null);

    useEffect(() => {
      if (divRef.current === null) {
        return;
      }
      // create a contextual fragment that will execute the script
      // beware of security concerns!!
      const doc = document.createRange().createContextualFragment(props.script);

      const currentRef: any = divRef.current;
      // clear the div HTML, and append the doc fragment with the script
      currentRef.innerHTML = '';
      currentRef.appendChild(doc);
    });

    return <div ref={divRef} />;
  });
  InjectScript.displayName = 'injectscript';
  return (
    data ? (
      <div>
        {ENABLE_GOOGLE_CONVERSION === 'yes' && <InjectScript script={scriptToInject} />}
        <div className="thankyou-page">
          <div className="top">
            <img src={Bouquet} />
            <h5>Appointment has been scheduled</h5>
            <p>
              Congratulations! the appointment for product tour has been confirmed successfully.
            </p>
          </div>
          <div className="time-container">
            <div className="schedule-demo-date">
              <p>
                <img src={DateIcon} />

                <span>{selectedSlot && Utils.getOnlyDate(selectedSlot.start, businessTz, 'MMM DD, yyyy')}</span>
              </p>
              <p>Scheduled date</p>
            </div>
            <div className="schedule-demo-time">
              <p>
                <img src={TimeIcon} />
                <span>{Utils.getOnlyDate(selectedSlot?.start, businessTz, 'hh:mm A')}</span>
              </p>
              <p>Scheduled time</p>
            </div>
          </div>
          <div className="meeting-details">
            <div className="">
              {googleMeetLink && (
                <div className="detail">
                  <label>Meeting link</label>
                  <p className="data">{googleMeetLink}</p>
                </div>
              )}
              <div className="detail">
                <label>Meeting duration</label>
                <p className="data">30 Minutes</p>
              </div>
              <div className="detail">
                <label>Meeting host</label>
                <div className="host-details">
                  <img src={hostBusinessData?.avatarUrl ? hostBusinessData?.avatarUrl : UserIcon} />
                  <div>
                    <p>{hostBusinessData?.name}</p>
                    <p>{hostBusinessData?.email}</p>
                  </div>
                </div>
              </div>
              <div className="detail">
                <label>Time zone</label>
                <p className="data">
                  {Utils.getTzAbbr(businessTz)} ({Utils.getOnlyDate(selectedSlot?.start, businessTz, 'hh:mm A')})
                </p>
              </div>
            </div>
          </div>
          <div className="action">
            <a onClick={backToWebsite}>Continue exploring website</a>
          </div>
        </div>
      </div>
    ) :(
      <div className='notification'>
        <div>Sorry, This page is not available. <a onClick={backToWebsite}>Go back to petsked Home</a></div>
      </div>
    )
  );
}
